export interface FirestoreDocument<T> {
    id: string;
    doc: T;
}

export interface Reference {
    id: string;
    label: string;
}

export enum Collection {
    User = "users",
    Payment = "payments",
    People = "people",
    Asset = "assets",
    Lead = "leads",
    Notification = "notifications",
    Shared = 'shared',
    SharedAsset = 'shared_assets',
    SharedReceipt = 'shared_receipts',
    StoreFront = "store_front",
    Store = 'Store',
    SharedInvoice = 'shared_invoices',
    ABTest = "abtest",
    InquiryNotification = "inquiry_notifications",
}